import type { ListingInput } from "@/lib/types/propertyTypes";
import { apiClient } from "../config";

interface ListingsParams {
  page?: number;
  limit?: number;
  propertyTypeId?: number;
  cityId?: number;
  minPrice?: number;
  maxPrice?: number;
  featured?: boolean;
}

interface BoostOption {
  boostOption: "30min" | "6h" | "24h";
}

interface FeatureOption {
  featureOption: "1d" | "7d" | "30d";
}

export const listingsService = {
  getAll: async (params: ListingsParams = {}) => {
    const { data } = await apiClient.get("/api/listings", { params });
    return data;
  },

  getById: async (id: number) => {
    const { data } = await apiClient.get(`/api/listings/${id}`);
    return data;
  },

  create: async (listing: ListingInput) => {
    const { data } = await apiClient.post("/api/listings", listing);
    return data;
  },

  update: async (id: number, listing: ListingInput) => {
    const { data } = await apiClient.put(`/api/listings/${id}`, listing);
    return data;
  },

  delete: async (id: number) => {
    const { data } = await apiClient.delete(`/api/listings/${id}`);
    return data;
  },

  boost: async (id: number, option: BoostOption) => {
    const { data } = await apiClient.post(`/api/listings/${id}/boost`, option);
    return data;
  },

  feature: async (id: number, option: FeatureOption) => {
    const { data } = await apiClient.post(
      `/api/listings/${id}/feature`,
      option
    );
    return data;
  },
};
